<template>
    <div data-name="show-rows">
        <Button 
            :id="[showedCount === 10 ? 'show-10-rows': 'show-20-rows']"
            type="rowCount" 
            @click.native="toggleRowCount(rowCount)">
                Show {{ showedCount }} rows
        </Button>
    </div>
</template>

<script>
import {useRouter} from '../../../core/hooks'
import {ref} from '@vue/composition-api'
import Button from './Button'
import {dashboardUtils} from '../../../core/utils'
export default {
    name: 'RowCount',
    components: {
        Button
    },
    setup(){
        const {route, router} = useRouter();
        const showedCount = ref(20)
        const rowCount = ref(route.value.query.perPage || dashboardUtils.DEFAULT_PER_PAGE);

        const setRowCount = (n) => {
            rowCount.value= n
            router.push({
                query: {
                    ...route.value.query,
                    perPage: n,
                    page: undefined
                }
            }).catch(e => {})
        }

        const toggleRowCount = (n) => {
            if(n === 10) {
                showedCount.value = 10
                return setRowCount(20)
            }
            showedCount.value = 20
            return setRowCount(10)

        }      


        return {
            showedCount,
            rowCount,
            toggleRowCount,
            setRowCount
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/variables.scss';
div[data-name="show-rows"] {
    position: relative;
    ul {
        margin: 0;
        padding: 0;
        color: $c1;
        font-size: $p5;
        background: $c29;
        position: absolute;
        width: 100%;

        li {
            text-align: center;
            transition: all 0.2s ease;
            cursor: pointer;
            &:hover {
                background: $c28;
            }
        }
    }
}
</style>